// extracted by mini-css-extract-plugin
module.exports = {"defaultContent":"DefaultContent_defaultContent__bihdu"};